import React, { useEffect, useState, useRef } from 'react';
import { GROUPS, OPEN_CHATS, OPEN_PROJECTS } from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { $user } from "../../helper/UserFactory";
import { Scrollbars } from "react-custom-scrollbars";
import "../../styles/pages.css"
import { $crud } from "../../helper/CrudFactory";
import LanguageContext from "../../helper/LanguageContext";
import { BASE_URL, KJUUP_COLORS } from '../../helper/constants';
import { Modal } from 'react-bootstrap';
import { stripMarkdown } from "../../utils/conversationUtils";
import { getUserInfo, roleLineOf } from "../../utils/roomPeople";
import {
    InfoAwayBanner,
    InfoCaption,
    InfoCard,
    InfoHero,
    InfoLeaveButton,
    InfoMemberRow,
    InfoRow,
    InfoTiles,
    InfoToggleRow,
    infoText,
    infoToneClass,
    myFullName,
    positionFormatter,
    useChatMediaCount,
} from "../../components/chat/info/ChatInfoParts";
import InfoExportCard from "../../components/chat/info/InfoExportCard";
import { lastOnlineText } from "../../utils/lastOnline";
import "./UserInfo.css";

const user = $user.get();

const avatarSrc = (path) => {
    if (!path) return "";
    return /^(https?:|blob:|data:)/.test(String(path)) ? path : BASE_URL + path;
};

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        overflowX: 'hidden',
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        {...props}
    />
);


function UserInfo(props) {

    const [chatDetails, setChatDetails] = useState({});
    const [loaded, setLoaded] = useState(false);
    const { isGerm, strings, language } = React.useContext(LanguageContext);
    const dispatch = useDispatch()
    const history = useHistory()
    const userN = useSelector((state) => state.user);
    const groups = useSelector((state) => state.groups);
    const [isAutomaticExportOn, setIsAutomaticExportOn] = useState(false);
    const [exportEmail, setExportEmail] = useState("");
    const [originalExportEmail, setOriginalExportEmail] = useState("");
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const [showChatHistoryRequest, setShowChatHistoryRequest] = useState(false);
    const [chatHistoryEmail, setChatHistoryEmail] = useState('');
    const [isLoadingChatHistory, setIsLoadingChatHistory] = useState(false);
    const toggleSwitchRef = useRef(null);
    const [isMuted, setIsMuted] = useState(false);
    const [showMuteConfirm, setShowMuteConfirm] = useState(false);
    const [showExportInfo, setShowExportInfo] = useState(false);
    const [showEmailInfo, setShowEmailInfo] = useState(false);
    const [unavailableMembers, setUnavailableMembers] = useState(props.unavailableMembers || []);
    const [isSelfChat, setIsSelfChat] = useState(!!(props.chatDetails?.isSelfChat || props.chat?.isSelfChat || props.chat?.group?.isSelfChat));
    // Export tile: scrolls to the export card and opens the PDF export (counter).
    const [exportSignal, setExportSignal] = useState(0);
    const exportCardRef = useRef(null);
    // "role · company" lines of you and the contact (GET /user/:id/info).
    const [roleLines, setRoleLines] = useState({});
    const mediaCount = useChatMediaCount(props.chat?.id, false);

    const getDetails = async () => {
        const id = props.chat?.id;
        const { data } = await callAPI(`/group/${id}/info`, {}, 'GET');
        if (data.status) {
            const selfChat = !!(data.groupInfo.isSelfChat || props.chat?.isSelfChat || props.chat?.group?.isSelfChat);
            setIsSelfChat(selfChat);
            const chatUser = selfChat
              ? (data.groupInfo.users.find(u => u.id === user?.id) || data.groupInfo.users[0])
              : data.groupInfo.users.filter(u => u.id !== user?.id)[0];
            setChatDetails(chatUser || {});
            console.log(chatUser);
            if (chatUser) setIsEmailOn(chatUser.emailNotification);
            setUnavailableMembers(Array.isArray(data.groupInfo.unavailableMembers) ? data.groupInfo.unavailableMembers : []);
            const currentUser = data.groupInfo.users.find(u => u.id === user?.id);
            if (currentUser) {
                setIsMuted(!!currentUser.isMute);
            }
            // Set automatic export settings from groupInfo (check both isChatExport and automaticExport)
            const exportEnabled = data.groupInfo.isChatExport !== undefined
                ? data.groupInfo.isChatExport
                : (data.groupInfo.automaticExport !== undefined ? data.groupInfo.automaticExport : false);
            setIsAutomaticExportOn(exportEnabled);
            // Set export email from groupInfo
            if (data.groupInfo.exportEmail) {
                setExportEmail(data.groupInfo.exportEmail);
                setOriginalExportEmail(data.groupInfo.exportEmail);
            } else if (userN?.email) {
                setExportEmail(userN.email);
                // Don't set originalExportEmail here - it hasn't been saved to group settings yet
                // This will make the Update button visible so user can save it
                setOriginalExportEmail("");
            }
            setLoaded(true)
        }
    };

    const toggleBlockUser = async () => {
        try {
            const wasBlocked = chatDetails.isBlock; // Capture state before toggle
            await $crud.confirm({
                title: wasBlocked ? strings.unblocks : strings.blocks,
                textContent: "",
                options: {
                    ok: strings.ok,
                    cancel: strings.cancel
                }
            });
            const id = props.chat?.id;
            const userId = chatDetails.id; // chatDetails is the other user (not the logged-in user)
            setViewLoader(true);
            const { data } = await callAPI(`/group/${id}/block`, {}, 'PUT', {
                id: id,
                user: userId
            });
            
            // Refresh the local chatDetails state
            await getDetails();
            
            // Update Redux groups state to reflect the new block status
            const updatedGroups = groups.map(group => {
                if (group.id === id) {
                    // Update the isBlock status for the other user in this group
                    const updatedUsers = group.users.map(u => {
                        if (u.id === userId) {
                            return { ...u, isBlock: !wasBlocked };
                        }
                        return u;
                    });
                    return { ...group, users: updatedUsers };
                }
                return group;
            });
            dispatch({ type: GROUPS, groups: updatedGroups });
            
            setViewLoader(false);
            // Show success notification based on what action was performed
            const successMessage = wasBlocked ? strings.unblock : strings.block;
            $crud.notify({
                type: "success",
                message: successMessage
            });
        } catch (error) {
            // User cancelled or error occurred
            setViewLoader(false);
            console.log('[UserInfo] Block/unblock cancelled or error:', error);
        }
    };
    const viewSearch = () => {
        if (typeof props.setSearch !== "function") return;
        props.setSearch();
        props.handleClose();
    };

    // Export tile: open the PDF export in the export card and scroll it into view.
    const goExport = () => {
        setExportSignal((n) => n + 1);
        setTimeout(() => {
            if (exportCardRef.current) exportCardRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 60);
    };

    const openReplacementChat = async (member) => {
        try {
            const { data } = await callAPI('/group', {}, 'POST', {
                groupType: 'user', isOneToOne: true, users: [user?.id, member.replacementUserId],
            });
            if (data?.chat?.id) {
                if (props.handleClose) props.handleClose();
                const chatPayload = { ...data.chat, isOpened: true, key: data.chat.id };
                dispatch({ type: OPEN_CHATS, openChats: [chatPayload] });
                dispatch({ type: OPEN_PROJECTS, openProjects: [] });
                history.push('/messages');
            }
        } catch (err) { console.error('Failed to open replacement DM:', err); }
    };

    const navigateUserProfile = (userId) => {
        if (!userId || isSelfChat) return;
        requestDirectMessage({
            id: userId,
            fullName: props?.chat?.name,
            avatar: props?.chat?.avatar,
        });
    }


    useEffect(() => {
        getDetails();
    }, []);

    // Members card: the role lines of you and the contact, once their ids are known.
    const contactId = chatDetails?.id;
    const myId = userN?.id || user?.id;
    useEffect(() => {
        if (isSelfChat || !contactId) return undefined;
        let live = true;
        const format = positionFormatter(strings);
        Promise.all([getUserInfo(contactId), myId ? getUserInfo(myId) : Promise.resolve(null)]).then(([contactInfo, myInfo]) => {
            if (!live) return;
            setRoleLines({
                contact: roleLineOf(contactInfo, format),
                me: roleLineOf(myInfo, format),
            });
        });
        return () => {
            live = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactId, myId, isSelfChat]);

    const [viewLoader, setViewLoader] = useState(false);
    const [isEmailOn, setIsEmailOn] = useState(false)

    useEffect(() => {
        setIsEmailOn(userN?.emailNotification)
    }, [userN])

    const _onPreEmailNotification = async () => {
        let emailNotification = !isEmailOn
        setIsEmailOn(emailNotification)
        await callAPI(`/group/emailNotification`, {}, "PUT", {
            emailNotification,
            group: props.chat?.id
        });
    }

    const handleMuteToggle = () => {
        setShowMuteConfirm(true);
    };

    const confirmMuteUnmute = async () => {
        const newMuteState = !isMuted;
        setShowMuteConfirm(false);
        try {
            const { data } = await callAPI(
                "/group/muteUnmuteChat",
                {
                    mute: newMuteState,
                    group: props.chat?.id,
                },
                "PUT"
            );

            if (data.status) {
                setIsMuted(newMuteState);
                $crud.notify({
                    type: "success",
                    message: newMuteState
                        ? strings.chat_muted_successfully
                        : strings.chat_unmuted_successfully,
                });

                const updatedGroups = groups.map((g) => {
                    if (g.id === props.chat?.id) {
                        const updatedUsers = g.users.map((u) =>
                            u.id === user?.id ? { ...u, isMute: newMuteState } : u
                        );
                        return { ...g, users: updatedUsers };
                    }
                    return g;
                });
                props.updateGroups(updatedGroups);
            } else {
                $crud.notify({
                    type: "error",
                    message: data.message || strings.something_went_wrong,
                });
            }
        } catch (error) {
            $crud.notify({
                type: "error",
                message: strings.something_went_wrong,
            });
        }
    };

    const cancelMuteUnmute = () => {
        setShowMuteConfirm(false);
    };

    const getAutomaticExportInfoText = () => {
        let text = strings.automatic_chat_export_info;
        if (!userN?.email) {
            text = `${text} ${strings.automatic_chat_export_no_email}`;
        } else if (!userN?.emailVerified) {
            text = `${text} ${strings.text_to_verifiy}`;
        }
        return text;
    };

    const toggleAutomaticExportInfo = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setShowExportInfo((open) => !open);
    };

    const handleAutomaticExportToggle = async () => {
        if (!userN?.emailVerified) {
            setShowExportInfo(true);
            return;
        }
        const newValue = !isAutomaticExportOn;
        setIsAutomaticExportOn(newValue);

        if (newValue && exportEmail) {
            // If enabling and email exists, save immediately without notification
            await saveAutomaticExportSettings(newValue, exportEmail, false);
        } else if (!newValue) {
            // If disabling, save immediately without notification
            await saveAutomaticExportSettings(newValue, exportEmail, false);
        }
    };

    const handleExportEmailChange = (e) => {
        const newEmail = e.target.value;
        setExportEmail(newEmail);
        // Show confirm button if email changed from original or if there's no original email saved
        if (newEmail !== originalExportEmail || !originalExportEmail) {
            setShowConfirmButton(true);
        } else {
            setShowConfirmButton(false);
        }
    };

    const handleConfirmEmail = async () => {
        if (!exportEmail || !exportEmail.includes('@')) {
            await $crud.notify({
                type: "error",
                message: isGerm ? "Bitte geben Sie eine gültige E-Mail-Adresse ein" : "Please enter a valid email address",
            });
            return;
        }
        await saveAutomaticExportSettings(isAutomaticExportOn, exportEmail);
    };

    const saveAutomaticExportSettings = async (enabled, email, showNotification = true) => {
        const id = props.chat?.id;
        try {
            const { data } = await callAPI(
                `/group/${id}/updateChatExportSetting`,
             {},
                "PUT",
                {
                    isChatExport: enabled,
                    exportEmail: email
                }
            );
            if (data.status) {
                if (showNotification) {
                    await $crud.notify({
                        type: "success",
                        message: isGerm ? "Einstellungen gespeichert" : "Settings saved",
                    });
                }
                // Update original email after successful save
                setOriginalExportEmail(email);
                setShowConfirmButton(false);
            } else {
                // Show the message from API (e.g., email confirmation required)
                // Don't hide the button if save failed - user needs to confirm email first
                await $crud.notify({
                    type: "warning",
                    message: data.message || (isGerm ? "Fehler beim Speichern" : "Error saving"),
                });
            }
        } catch (error) {
            await $crud.notify({
                type: "error",
                message: isGerm ? "Fehler beim Speichern" : "Error saving",
            });
        }
    };

    useEffect(() => {
        if (userN?.email && !exportEmail) {
            setExportEmail(userN.email);
            setOriginalExportEmail(userN.email);
        }
    }, [userN?.email]);

    useEffect(() => {
        // Pre-fill email if user has one
        if (userN?.email) {
            setChatHistoryEmail(userN.email);
        }
    }, [userN?.email]);

    useEffect(() => {
        // Apply border color directly to the input element after DOM updates
        const switchId = `custom-switch-automatic-export-one-to-one-${props.chat?.id}`;
        const applyStyles = () => {
            const inputElement = document.getElementById(switchId);
            if (inputElement) {
                const borderColor = props.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color;
                inputElement.style.setProperty('border-color', borderColor, 'important');
                inputElement.style.setProperty('border-width', '1px', 'important');
                if (isAutomaticExportOn) {
                    inputElement.style.setProperty('background-color', borderColor, 'important');
                    inputElement.style.setProperty('border-color', borderColor, 'important');
                } else {
                    inputElement.style.setProperty('background-color', '#ccc', 'important');
                }
            }
        };

        // Apply immediately and after a short delay to ensure DOM is ready
        applyStyles();
        const timeoutId = setTimeout(applyStyles, 100);
        return () => clearTimeout(timeoutId);
    }, [isAutomaticExportOn, props.chat?.id, loaded, props.isInternal]);

    useEffect(() => {
        // Remove inline styles from automatic export email section and ensure CSS is applied
        const removeInlineStyles = () => {
            const emailSection = document.querySelector('.automatic-export-email-section');
            if (emailSection) {
                // Remove inline padding and border styles to let CSS take over
                emailSection.style.removeProperty('padding');
                emailSection.style.removeProperty('padding-top');
                emailSection.style.removeProperty('padding-right');
                emailSection.style.removeProperty('padding-bottom');
                emailSection.style.removeProperty('padding-left');
                emailSection.style.removeProperty('border');
                // Ensure CSS class is applied
                if (!emailSection.classList.contains('automatic-export-email-section')) {
                    emailSection.classList.add('automatic-export-email-section');
                }
            }
        };

        if (isAutomaticExportOn) {
            // Apply immediately and after delays to catch any dynamically added styles
            removeInlineStyles();
            const timeoutId1 = setTimeout(removeInlineStyles, 50);
            const timeoutId2 = setTimeout(removeInlineStyles, 200);
            return () => {
                clearTimeout(timeoutId1);
                clearTimeout(timeoutId2);
            };
        }
    }, [isAutomaticExportOn, props.chat?.id]);

    const handleChatHistoryRequest = () => {
        setShowChatHistoryRequest(!showChatHistoryRequest);
    };

    const handleConfirmChatHistoryRequest = async () => {
        if (!chatHistoryEmail.trim() || isLoadingChatHistory) {
            return;
        }

        setIsLoadingChatHistory(true);
        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const { data } = await callAPI(
                `/group/${props.chat?.id}/exportFullChat`,
                {
                    timezone: timeZone,
                    lang: isGerm ? 'de' : 'en',
                    viewByOwner: false,
                    email: chatHistoryEmail
                },
                'GET'
            );

            if (data && data.status) {
                // Success - show success message or close form
                setShowChatHistoryRequest(false);
                await $crud.notify({
                    type: "success",
                    message: data.message || (isGerm ? "Chatverlauf-Anfrage erfolgreich gesendet" : "Chat history request sent successfully"),
                });
            } else {
                await $crud.notify({
                    type: "error",
                    message: (data && data.message) || (isGerm ? "Chatverlauf-Anfrage konnte nicht gesendet werden" : "Failed to send chat history request"),
                });
            }
        } catch (error) {
            console.log('Error requesting chat history:', error);
            await $crud.notify({
                type: "error",
                message: isGerm ? "Fehler beim Anfordern des Chatverlaufs" : "Error requesting chat history",
            });
        } finally {
            setIsLoadingChatHistory(false);
        }
    };

    const contactName = isSelfChat
        ? (strings.my_notes || "My Space")
        : stripMarkdown((props?.chat?.name || chatDetails?.fullName || "").replace(/All members of the (room|project)/, strings.all_member_of_project));
    const online = !!chatDetails?.isOnline;
    const presenceLabel = online
        ? infoText(strings, isGerm, "chat_info_online", "Online", "Online")
        : lastOnlineText(chatDetails?.lastOnlineAt, strings, language);
    const pageTitle = isSelfChat
        ? infoText(strings, isGerm, "chat_info_title_chat", "Chat-Info", "Chat info")
        : infoText(strings, isGerm, "chat_info_title_contact", "Kontaktinfo", "Contact info");
    const awayMembers = isSelfChat ? [] : unavailableMembers.filter((u) => u.userId !== user?.id);
    const emailDisabled = !userN?.emailNotification || !userN?.emailVerified;
    const tiles = [
        typeof props.setSearch === "function"
            ? { key: "search", icon: "search", label: strings.search || (isGerm ? "Suche" : "Search"), onClick: viewSearch }
            : null,
        !isSelfChat
            ? {
                key: "mute",
                // Short tile words, as on mobile ("Stummschaltung aufheben" does not fit a tile).
                icon: isMuted ? "notifications" : "notifications_off",
                label: isMuted
                    ? infoText(strings, isGerm, "chat_info_unmute", "Ton an", "Unmute")
                    : infoText(strings, isGerm, "chat_info_mute", "Stumm", "Mute"),
                ariaLabel: isMuted ? strings.unmute : strings.mute,
                onClick: handleMuteToggle,
            }
            : null,
        props.viewMediaDoc
            ? { key: "media", icon: "perm_media", label: infoText(strings, isGerm, "chat_info_media", "Dateien", "Files"), onClick: props.viewMediaDoc }
            : null,
        { key: "export", icon: "picture_as_pdf", label: infoText(strings, isGerm, "chat_info_export", "Export", "Export"), onClick: goExport },
    ];
    // Design: "Members · 2" with you (your full name) and the contact, each with "role · company".
    const members = isSelfChat
        ? []
        : [
            {
                key: "me",
                name: myFullName(userN) || myFullName(user) || strings.me || "Me",
                src: avatarSrc(userN?.avatar || user?.avatar),
                roleLine: roleLines.me || "",
            },
            {
                key: String(chatDetails?.id || "contact"),
                name: contactName,
                src: avatarSrc(chatDetails?.avatar || props.chat?.avatar),
                roleLine: roleLines.contact || "",
                presence: chatDetails?.id ? { online, label: presenceLabel } : null,
            },
        ];

    return (
        <React.Fragment>
            <div className={`chat_user_info group_chat_user_info border-radius-0 m-0 p-0 user-info kjp-info-shell${props.isInternal ? ` chat_user_info-internal user-info--internal${infoToneClass(true)}` : ""}`}>
                {viewLoader && (
                    <div className="website_loader">
                        <div className="loader" />
                    </div>
                )}
                <div className="kjp-info-head">
                    <button
                        type="button"
                        className="kj-btn kj-btn--icon kj-btn--neutral kjp-info-head__back"
                        onClick={props.handleClose}
                        aria-label={strings.back || (isGerm ? "Zurück" : "Back")}
                        title={strings.back || (isGerm ? "Zurück" : "Back")}
                    >
                        <span className="material-symbols-outlined">keyboard_arrow_left</span>
                    </button>
                    <div className="kjp-info-head__title">{pageTitle}</div>
                </div>
                <div className="kjp-info-shell__body">
                    <CustomScrollbars autoHide autoHideTimeout={200} autoHideDuration={200} className="bottom-bar">
                        <div className={`kjp-info${infoToneClass(props.isInternal)}`}>
                            <InfoHero
                                kind={isSelfChat ? "self" : "person"}
                                name={contactName}
                                src={isSelfChat ? "" : avatarSrc(chatDetails?.avatar || props.chat?.avatar)}
                                sub={isSelfChat || !chatDetails?.id ? null : presenceLabel}
                                onClick={!isSelfChat && chatDetails?.id ? () => navigateUserProfile(chatDetails.id) : undefined}
                            />
                            <InfoAwayBanner
                                members={awayMembers}
                                showName={false}
                                contactLabel={strings.unavailability_contact_urgent}
                                onContactReplacement={openReplacementChat}
                            />
                            <InfoTiles tiles={tiles} />
                            <InfoCard>
                                {props.viewMediaDoc ? (
                                    <InfoRow
                                        key="media"
                                        icon="photo"
                                        label={strings.media_link_docs}
                                        value={mediaCount != null ? String(mediaCount) : null}
                                        onClick={props.viewMediaDoc}
                                    />
                                ) : null}
                                {!isSelfChat ? (
                                    <InfoToggleRow
                                        key="email"
                                        icon="mail"
                                        label={strings.email_on_grp}
                                        checked={emailDisabled ? false : isEmailOn}
                                        disabled={emailDisabled}
                                        dim={emailDisabled}
                                        onToggle={() => { _onPreEmailNotification() }}
                                        id={`custom-switchx-setting-user-group-one-to-one-${props.chat?.id}`}
                                        isInternal={props.isInternal}
                                        infoOpen={showEmailInfo}
                                        onInfo={() => setShowEmailInfo((open) => !open)}
                                        onRowClick={!userN?.emailVerified ? () => setShowEmailInfo((open) => !open) : undefined}
                                        note={
                                            <>
                                                {strings.email_groups}
                                                {!userN?.emailVerified ? ` ${strings.text_to_verifiy}` : ""}
                                            </>
                                        }
                                    />
                                ) : null}
                            </InfoCard>
                            {members.length ? (
                                <InfoCaption title={`${infoText(strings, isGerm, "chat_info_members", "Mitglieder", "Members")} · ${members.length}`} />
                            ) : null}
                            {members.length ? (
                                <InfoCard>
                                    {members.map((m) => (
                                        <InfoMemberRow key={m.key} m={m} />
                                    ))}
                                </InfoCard>
                            ) : null}
                            <InfoExportCard
                                ref={exportCardRef}
                                isInternal={props.isInternal}
                                autoExport={{
                                    enabled: isAutomaticExportOn,
                                    onToggle: handleAutomaticExportToggle,
                                    email: exportEmail,
                                    onChangeEmail: handleExportEmailChange,
                                    savedEmail: originalExportEmail,
                                    emailVerified: !!userN?.emailVerified,
                                    onUpdate: handleConfirmEmail,
                                    infoOpen: showExportInfo,
                                    onInfo: toggleAutomaticExportInfo,
                                    onRowClick: !userN?.emailVerified ? () => setShowExportInfo((open) => !open) : undefined,
                                    switchId: `custom-switch-automatic-export-one-to-one-${props.chat?.id}`,
                                    note: (
                                        <>
                                            {getAutomaticExportInfoText()}
                                            {!userN?.emailVerified && (
                                                <>
                                                    {" "}
                                                    <a
                                                        href="#profile-setting"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            history.push("/profile-setting");
                                                        }}
                                                    >
                                                        {strings.email_go_to_settings}
                                                    </a>
                                                </>
                                            )}
                                        </>
                                    ),
                                }}
                                pdf={{ chat: props.chat, openSignal: exportSignal }}
                                history={{
                                    open: showChatHistoryRequest,
                                    onToggle: handleChatHistoryRequest,
                                    email: chatHistoryEmail,
                                    onChangeEmail: (e) => setChatHistoryEmail(e.target.value),
                                    onConfirm: handleConfirmChatHistoryRequest,
                                    loading: isLoadingChatHistory,
                                    placeholder: userN?.email ? strings.email : strings.enter_your_email_add,
                                }}
                            />
                            {!isSelfChat ? (
                                <InfoLeaveButton
                                    icon="block"
                                    tone={chatDetails?.isBlock ? "ink" : "err"}
                                    label={chatDetails?.isBlock ? strings.unblock : strings.block}
                                    onClick={toggleBlockUser}
                                />
                            ) : null}
                        </div>
                    </CustomScrollbars>
                </div>
            </div>
            {/* Mute/Unmute Confirmation Modal */}
            <Modal
                show={showMuteConfirm}
                onHide={cancelMuteUnmute}
                animation={false}
                centered
            >
                <Modal.Body className="modal-body-relative">
                    <p>
                        {!isMuted
                            ? strings.mute_chat_confirm
                            : strings.unmute_chat_confirm
                        }
                    </p>
                </Modal.Body>
                <Modal.Footer className="user-info__modal-footer">
                    <button
                        onClick={cancelMuteUnmute}
                        className="kj-btn kj-btn--outline kj-btn--on-surface"
                    >
                        {strings.cancel}
                    </button>
                    <button
                        onClick={confirmMuteUnmute}
                        className="kj-btn kj-btn--primary"
                    >
                        {strings.ok}
                    </button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    const { openChats, groups } = state;
    return {
        groups: groups,
        openChats: openChats,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        updateGroups: groups => dispatch({ type: GROUPS, groups: groups }),
        updateOpenChatsList: chats => dispatch({ type: OPEN_CHATS, openChats: chats }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserInfo));
